import { Injectable } from '@angular/core';
import { CompanyEditSSOProvider } from 'src/AngularJS/Admin/Company/company-edit-sso.model';
import { SsoSettings } from 'src/app/admin/company-settings/company-edit-sso/company-edit-sso.model';
import { CVApiService } from '../../reusables/services/cv-api.service';
import { CompanySettingsValues, SSOSettingsValues } from "./company-settings.models";

@Injectable({
  providedIn: 'root'
})
export class CompanySettingsService {

    constructor(
        public cvApiService: CVApiService,
    ) { }

    public async GetCompanySettings(): Promise<CompanySettingsValues[]> {
        try {
            let response = await this.cvApiService.get<CompanySettingsValues[]>(`/api/v2/company-settings`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting company settings.");
            throw err;
        }
    }

    public async GetSSOSettings(): Promise<SsoSettings> {
        try {
            let response = await this.cvApiService.get<SsoSettings>(`/api/v2/company-sso-settings`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting company sso settings.");
            throw err;
        }
    }

    public async SetCompanySettings(changes: CompanySettingsValues[]): Promise<boolean> {
        if (changes == null || changes.length == 0) return false;

        try {
            let response = await this.cvApiService.post(`/api/v2/company-settings/`, changes);
            if (response.status_code >= 200 && response.status_code < 300)
                return true;
            else throw response;
        } catch (err) {
            console.error("Failed updating company settings.");
            throw err;
        }
    }

    public async SetCompanySSOSettings(changes: SsoSettings): Promise<SsoSettings> {
        if (changes == null) return null;

        try {
            let response = await this.cvApiService.post<SsoSettings>(`/api/v2/company-sso-settings/`, changes);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed updating company sso settings.");
            throw err;
        }
    }
}
